// interfaces/types
import type { StateTree, DealLifecycle } from '@makemydeal/dr-dash-types';
import { UpdateDealLifecycleStatus } from '@makemydeal/dr-dash-types';

export const getDealLifecycle = (state: StateTree): DealLifecycle => {
    const safeDefault: DealLifecycle = {
        updateDealLifecycleStatus: UpdateDealLifecycleStatus.Ready
    };
    return state.dealLifecycle || safeDefault;
};

export const getDealLifecycleStatus = (state: StateTree): string => {
    return state.dealLifecycle?.status || '';
};

export const getDealLifecycleCreatedOn = (state: StateTree): string | undefined => {
    return state.dealLifecycle?.createdOn;
};

export const getUpdateDealLifecycleStatus = (state: StateTree) => {
    const dealLifecycle = getDealLifecycle(state);
    return dealLifecycle.updateDealLifecycleStatus;
};

export const getShowDealLifeCycleModal = (state: StateTree): boolean => {
    return state.dealLifecycle?.showDealLifeCycleModal || false;
};

export const getShowDealLifeCycleModalLoader = (state: StateTree): boolean => {
    return state.dealLifecycle?.showDealLifeCycleModalLoader || false;
};

export const getHasContractSignDateUpdated = (state: StateTree): boolean => {
    return state.dealLifecycle?.hasContractSignDateUpdated || false;
};
